import {mrbgStore, add2ActiveFormPanel, updateVars, setToken, updateNotification, setSettingsForm, mrbgSlice} from './../components/mrbg/mrbgRedux';

/* BABAK GOLBAHARAN 0938 443 9494 */
// MRBG ROLLS
// __BC => BAR CHART
// __BL => BACK LOCATION
// __DL => DATA LIST
// __DS => DISABLE INPUT
// __EI => EMPTY INPUTS
// __FB => FORM BUTTON
// __FC => FULL CHART
// __FF => FILL FORM
// __GM => GREEN MESSAGE
// __HI => HIDE INPUTS
// __ID => REPLACE WITH ELEMENT BY THIS ID
// __IV => INVALID VALUE
// __NL => NEW LOCATION
// __NT => NOTIFICATION
// __NW => NOTIFICATION WARRING
// __PC => PIE CHART
// __PL => PARTS LENGTH
// __RD => REDUCER: [actionName => payload]
// __RL => RELOAD
// __RM => RED MESSAGE
// __RS => SUCCESS RESIGN IN
// __RF => REFERENCE OPTIONS FOR RELATIVE SELECT
// __SL => SORT LIST
// __ST => SELECT TAG
// __TB => TABLE
// __TT => TABLE TITLE ( 1 until 40 FROM 1000)
// __TL => TIME LINE
// __TM => TIMER
// __TO => tmpOp
// __VA => VARIABLE
// __XP => LOGIN EXPIRED
// __TFI => TARGET FORM ID
// __MSG => TEXT FOR FILL FORM

export const Mrbg = {
  lockForm: [],
  keepLoader: false
};
Mrbg.dataProcessing = function( formID, data, status ){

  if( typeof data == 'object' ){
    var
      __TK = null,
      __RD = null;

    if( Object.hasOwn(data,'__TK') ){
      __TK = data.__TK;
      delete data.__TK;
    }
    if( Object.hasOwn(data,'__RD') ){
      __RD = data.__RD;
      delete data.__RD;
    }

    var msg =
      status>=200 && status<299?
        Mrbg.successRequest( formID, data ):
        Mrbg.failedRequest ( formID, data );

    if( __RD ){
      Object.keys(__RD).forEach(actionName => {
        Object.hasOwn(mrbgSlice.actions,actionName)?
          mrbgStore.dispatch(mrbgSlice.actions[actionName](__RD[actionName])):
          console.log(`actions ${actionName} not Found`)
      });
    }

    if( __TK )
      Mrbg.tokenDecode(__TK);

    return msg;
  }
  else if( data ){
    if( formID )
      Mrbg.formSetting(formID, {__RM:data}, [], []);
    else
      return data;
  }
}
Mrbg.successRequest = ( formID, data )=>{

  var
    mrbgVars = {},
    __HI = {},
    __TM = {};

  for(var i in data){
    let
      roll= i.substring(i.length-4),
      key = i.substring(0, i.length-4);

    if( roll==='__FF' ){
      var
        targetFormID = key,
        formsList = mrbgStore.getState().mrbgVars.formsList;
      if( !targetFormID ){
        let fi = formID.replace('__TF','');
        if( formsList.includes(`${fi}Upd`) )
          targetFormID = fi+'Upd';
        else if( formsList.includes(`${fi}Ins`) )
          targetFormID = fi+'Ins';
        else if( formsList.includes(fi) )
          targetFormID = fi;
        else
          targetFormID = formID;
      }
      Mrbg.keepLoader = true;
      mrbgStore.dispatch(add2ActiveFormPanel(`${targetFormID}Frame`));
      var
        intVal = setInterval(()=>{
          if( document.querySelector(`form[data-id="${targetFormID}"]`) ){
            document.querySelector(`form[data-id="${targetFormID}"]`).mrbgFillForm(data[i])
            clearInterval(intVal)
            delete( data[i] );
          }
        },100)
    }
    else if( ['__HI','__TM'].includes(roll) ){
      roll==='__HI'?
        __HI = Object.assign( {...__HI}, {[key]:{...data[i]}} ):
        __TM = Object.assign( {...__TM}, {[key]:data[i]} );
      delete( data[i] );
    }
    else if( ['__ST','__TB','__TT','__SL','__RF','__PC','__BC','__TL','__SS','__FC','__PC'].includes(roll) ){
      mrbgVars = { ...mrbgVars, [i]:data[i] };
      delete data[i];
    }
    else if( roll=='__DL' ){
      mrbgVars.datalist = { ...{...mrbgVars.datalist||{}}, [i]:data[i] };
      delete data[i];
    }
    else if( ['__ID','__VA'].includes(roll) ){
      mrbgVars = {
        ...mrbgVars,
        [key]: data[i]
      };
      delete data[i];
    }
  }

  if( formID && !Mrbg.lockForm.includes(formID) && !Object.hasOwn(data,'__DRF') )
    document.getElementByDataID(formID).mrbgReset();
  else if( Object.hasOwn(data,'__DRF') )
    delete data.__DRF;

  if( Object.keys(mrbgVars).length )
    mrbgStore.dispatch(updateVars(mrbgVars))

  if( Object.hasOwn(data,'__NT') )
    mrbgStore.dispatch(updateNotification(data.__NT));

  if( formID )
    return Mrbg.formSetting(formID, data, [], [], __HI, __TM);
  else{
    if( document.getElementByDataID('mrbgLoader') && !Mrbg.keepLoader )
      document.getElementByDataID('mrbgLoader').removeAttribute('style');
    return data;
  }
}
Mrbg.failedRequest  = (formID, data)=>{

  var
    __EI = [],
    __II = [];

  if( Object.hasOwn(data,'__XP') || Object.hasOwn(data,'__RS') ){
    if( Object.hasOwn(data,'__XP') ){
      // document.querySelector('*[errData-id="reSignIn"]').style.display = 'block';
      // document.getElementById('popupFrame').style.display = 'block';
    }
    else{
      // $('#reSignIn').mrbgResetForm();
      // document.querySelector('*[errData-id="reSignIn"]').removeAttribute('style');
      // document.getElementById('popupFrame').removeAttribute('style');
      // document.getElementById('mrbgRecaptcha').dispatchEvent( MrbgEvent.click );
    }
  }
  else{
    if( Object.hasOwn(data,'__II') ){
      __II = __II.concat( data.__II );
      delete data.__II;
    }
    if( Object.hasOwn(data,'__EI') ){
      __EI = __EI.concat( data.__EI );
      delete data.__EI;
    }

    var mrbgVars = [];
    for(var i in data){
      let
        roll= i.substring(i.length-4),
        key = i.substring(0, i.length-4);
      if( ['__ID','__VA'].includes(roll) ){
        mrbgVars = {
          ...mrbgVars,
          [key]: data[i]
        };
        delete data[i];
      }
    }
    if( Object.keys(mrbgVars).length )
      mrbgStore.dispatch(updateVars(mrbgVars))

    return Mrbg.formSetting(formID, data, __EI, __II);
  }
}
/**
 * @param formID SUBMITED FORMS ID
 * @param data   RETURNED FROM BACK END
 * @param EI     ARRAY OF EMPTY INPUTS                   EXAMPLE => [ID,NAME,FAMILY,...]
 * @param II     ARRAY OF INVALID INPUTS                 EXAMPLE => [MAIL,PHONE,...]
 * @param HI     OBJECT OF HIDE INPUTS                   EXAMPLE => {
 *                                                                    OWNER_FORM_ID: { INPUT_NAME: INPUT_VALUE }
 *                                                                  }
 * @param TM     OBJECT OF TIMER                         EXAMPLE => {
 *                                                                    OWNER_FORM_ID: 180       //MEANS 3 MINUTES
 *                                                                  }
 * @returns {boolean}
 */
Mrbg.formSetting = function( formID,data,EI,II,HI,TM ){

  if( formID && !document.getElementByDataID(formID) && data ){
    return 'msgText:'+"\n"+data;
  }

  var fs = {}

  if( formID ){
    fs[formID] = {...mrbgStore.getState().formsSettings[formID]}
    fs[formID].redFld = Object.assign(EI,II);
    fs[formID].msgTxt = {};
    if( typeof data == 'object' ){
      if( Object.hasOwn(data,'__GM') )
        fs[formID].msgTxt.__GM = data.__GM;
      if( Object.hasOwn(data,'__RM') )
        fs[formID].msgTxt.__RM = data.__RM;
    }
    else
      fs[formID].msgTxt.__RM = data;
  }

  for( let k in HI ){
    if( !fs[k] )
      fs[k] = {...mrbgStore.getState().formsSettings[k]}
    fs[k].hideInp = Object.assign( fs[k].hideInp, HI[k])
  }

  for( let k in TM ){
    if( !fs[k] )
      fs[k] = {...mrbgStore.getState().formsSettings[k]}
    fs[k].timer=TM[k];
  }

  if( Object.keys(fs).length )
    mrbgStore.dispatch(setSettingsForm(fs));

  if( document.getElementByDataID('mrbgLoader') && !Mrbg.keepLoader )
    document.getElementByDataID('mrbgLoader').removeAttribute('style');

  if( !formID ){
    if( Object.hasOwn(data,'__GM') )
      return data.__GM
    else if( Object.hasOwn(data,'__RM') )
      return data.__RM;
  }
}
Mrbg.tokenDecode = function( token ){

  var tokenData = {};

  for( let k in token )
    tokenData[k] = atob(token[k].split('.')[1]||'').isJson();

  mrbgStore.dispatch(setToken(tokenData));
  localStorage.setItem('token',JSON.stringify(token));
}
Mrbg.logResponse = async function (response) {
  try{
    let logMessage;
    if( typeof response === 'object' && response !== null ){
      logMessage = JSON.stringify(response, null, 2); // تبدیل آبجکت به رشته JSON با تورفتگی
    }
    else{
      logMessage = String(response); // تبدیل هر نوع دیگر به رشته
    }

    const filename   = 'response_log.txt';
    const fileHandle = await window.showSaveFilePicker({
      suggestedName: filename,
      types: [{
        description: 'Text file',
        accept: { 'text/plain': ['.txt'] },
      }],
    });

    const writable = await fileHandle.createWritable();
    await writable.write(logMessage+'\n--------------------\n'); // نوشتن پیام و جداکننده
    await writable.close();


  }
  catch( err ){
    console.error('Failed to log response:', err);
  }
}